import SlsWebLogger from 'js-sls-logger'
import _ from 'lodash'

let logger = null
if (process.env.VUE_APP_SLS_LOGGER_ENABLE !== 'true') {
  logger = {
    // eslint-disable-next-line no-console
    send: console.log
  }
} else {
  logger = new SlsWebLogger({
    host: 'cn-hangzhou.log.aliyuncs.com',
    project: 'ajinga-prod',
    logstore: 'frontend-vue',
    time: 10,
    count: 10
  })
}

const originalConsole = {
  // eslint-disable-next-line no-console
  log: console.log.bind(console),
  // eslint-disable-next-line no-console
  info: console.info.bind(console),
  // eslint-disable-next-line no-console
  warn: console.warn.bind(console),
  // eslint-disable-next-line no-console
  error: console.error.bind(console),
  // eslint-disable-next-line no-console
  debug: console.debug ? console.debug.bind(console) : console.log.bind(console)
}

function normalizeValue (value) {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack
    }
  }

  if (typeof value === 'undefined') {
    return 'undefined'
  }

  if (typeof value === 'function') {
    return `[Function ${value.name || 'anonymous'}]`
  }

  return value
}

function sendConsoleMessage (level, args) {
  if (process.env.VUE_APP_SLS_LOGGER_ENABLE !== 'true') {
    return
  }

  logger.send({
    type: `console.${level}`,
    from: 'console',
    href: window.location.href,
    userAgent: window.navigator.userAgent,
    data: {
      args: args.map(normalizeValue)
    }
  })
}

_.forEach(['log', 'info', 'warn', 'error', 'debug'], (level) => {
  const originalMethod = originalConsole[level] || originalConsole.log

  // eslint-disable-next-line no-console
  console[level] = (...args) => {
    originalMethod(...args)
    sendConsoleMessage(level, args)
  }
})

export default logger
